export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REDIRECT_URL = 'REDIRECT_URL';
export const REDIRECT_AFTER_RESET_URL = 'REDIRECT_AFTER_RESET_URL';

export const REQUEST_URLS = {
  AUTH_LOGIN_PASSWORD: '/v1/auth/login',
  AUTH_FORGOT_PASSWORD: '/v1/auth/forgot',
  AUTH_VERIFY_FORGOT_PASSWORD: '/v1/auth/forgot/verify',
  AUTH_RESET_PASSWORD: '/v1/auth/reset',
  AUTH_REFRESH: '/v1/auth/refresh',
  UNSUBSCRIBE_EMAIL: 'v1/notification-subscriptions/opt-out',
};
